var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1 -1 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-171,-304)",
    fill: "#fff",
    strokeWidth: 1.5,
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(171,304)",
    d: "m11.678 9.6777c-0.43792 0.073919-0.80087 0.41806-1.1914 0.80859-0.78103 0.78104-1.3724 1.4557 0 2.8281l3.5254 3.5254-3.6699 3.6699c-0.7084 1.1772-0.70838 2.1197 0 2.8281 1.0626 1.0626 2.0053 0.82279 2.8281 0l3.6699-3.6699 3.6699 3.6699c1.1772 0.7084 2.1197 0.70838 2.8281 0 1.0626-1.0626 0.82279-2.0053 0-2.8281l-3.6699-3.6699 3.5254-3.5254c1.3724-1.3724 0.78107-2.0471 0-2.8281-0.78103-0.78103-1.4557-1.3724-2.8281 0l-3.5254 3.5254-3.5254-3.5254c-0.68621-0.68621-1.1988-0.88251-1.6367-0.80859z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171,304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17 0c-9.3888 0-17 7.6112-17 17 0 9.3889 7.6112 17 17 17 9.3889 0 17-7.6111 17-17 0-9.3888-7.6111-17-17-17zm-12.143 17c0-6.7063 5.4366-12.143 12.143-12.143 6.7063 0 12.143 5.4366 12.143 12.143 0 6.7063-5.4366 12.143-12.143 12.143-6.7063 0-12.143-5.4366-12.143-12.143z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleted);
export default __webpack_public_path__ + "static/media/deleted.75aaf3b6becff8d41ccc8b187de52c9d.svg";
export { ForwardRef as ReactComponent };